import { createEntityAdapter } from '@ngrx/entity';
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { LoadingStatus, PortfolioMandateType } from '@qvs/core';
import * as fromActions from './mandateType.actions';
import { onEntityLoadingStatus } from '~/shared/helpers/loading-status-helper';

const mandateTypesEntityAdapter = createEntityAdapter<PortfolioMandateType>();

export const initialState = mandateTypesEntityAdapter.getInitialState({
  loadingStatus: LoadingStatus.IDLE
});

export type State = typeof initialState;

export const mandateTypesFeatureKey = 'mandateTypes';

const reducer = createReducer(
  initialState,
  on(fromActions.upsertMandateTypes, (state, { entities }) => mandateTypesEntityAdapter.upsertMany(entities, state)),
  ...onEntityLoadingStatus<State>(
    fromActions.loadMandateTypes,
    fromActions.loadMandateTypesSuccess,
    fromActions.loadMandateTypesFailure
  )
);

export const mandateTypesFeature = createFeature({
  name: mandateTypesFeatureKey,
  reducer
});

const { selectMandateTypesState } = mandateTypesFeature;

export const selectLoadingStatus = createSelector(selectMandateTypesState, (state) => state.loadingStatus);

export const selectMandateTypeEntities = createSelector(
  selectMandateTypesState,
  mandateTypesEntityAdapter.getSelectors().selectEntities
);

export const selectMandateTypeDescription = (id: string) =>
  createSelector(selectMandateTypeEntities, (mandateTypes) => mandateTypes[id]?.description);
